import React, { Fragment } from 'react';

import { IWidgetGeneratorState } from '../..';
import getFormattedPropertyName from '../../../../lib/getFormattedPropertyName';
import ColorSelector from '../../../ColorSelector';
import { MaterialInput } from '../../../FormInput';
import { FormInputLabel } from '../../../Typography';
import { Column, Section } from '../../styled';
import CtaButton from '../CtaButton/CtaButton';
import { WidgetContainer } from '../WidgetEditor/styled';

const ctaButtonColorKeys = ['buttonBackgroundColor', 'buttonTextColor'];

interface IChatButtonEditorProps {
  options: IWidgetGeneratorState;
  updateWidget: (key: string, value: string | number | boolean, refresh?: boolean) => void;
}

const ChatButtonEditor = (props: IChatButtonEditorProps) => {

  const { options, updateWidget } = props;

  return (
    <Fragment>
      <Column>
        <Section>
          <FormInputLabel marginBottom bold>BUTTON TEXT</FormInputLabel>
          <MaterialInput
            variant='outlined'
            label={'Title'}
            value={options.buttonText}
            onChange={event => updateWidget('buttonText', event.target.value)}
          />
        </Section>
        <Section>
          <FormInputLabel bold>BUTTON COLORS</FormInputLabel>
          {ctaButtonColorKeys.map(colorKey => (
            <ColorSelector
              key={colorKey}
              title={getFormattedPropertyName(colorKey)}
              color={options[colorKey]}
              onChange={color => updateWidget(colorKey, color.hex)} />
          ))}
        </Section>
      </Column>
      <Column>
        <WidgetContainer width={options.width} height={options.height}>
          <CtaButton
            text={options.buttonText || ''}
            backgroundColor={options.buttonBackgroundColor || ''}
            textColor={options.buttonTextColor || ''}
          />
        </WidgetContainer>
      </Column>

    </Fragment>
  );
};

export default ChatButtonEditor;
